module.exports = function(ctx) {
var __t, __p = '';
__p += '<div class="text-muted text-center p-2">' +
((__t = ( ctx.t(ctx.component.title) )) == null ? '' : __t) +
'</div>';
return __p
}